module.exports = __webpack_public_path__ + "img/mileage.8972637f.svg";